/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormLabel, Textarea, TextareaProps } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useField } from 'formik';
import { Control, MetaError } from './Control';

const TextareaStyled = styled(Textarea)`
  border-color: ${({ theme }) => theme.colors.asphalt[3]};
  background: ${({ theme }) => theme.colors.white};
  border-radius: 8px;

  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.asphalt[1]};
    font-size: 14px;
  }
`;

export const FormTextarea: React.FC<
  TextareaProps & { name: string; label?: string }
> = ({ className, name, label, placeholder, ...rest }) => {
  const [input, meta] = useField(name);

  return (
    <Control name={name} my={4} className={className}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <TextareaStyled
        {...input}
        {...rest}
        isInvalid={!!meta.error && meta.touched}
        id={name}
        placeholder={placeholder}
      />
      <MetaError name={name} />
    </Control>
  );
};

export { FormTextarea as Textarea };
